import { createStore } from 'vuex';  // Importing createStore for Vuex 4
import AuthModule from "@/store/auth.module";
import SessionModule from "@/store/session.module";
import ItemsModule from "@/store/items.module";

export default createStore({
  strict: true,
  modules: {
    auth: AuthModule,
    session: SessionModule,
    items: ItemsModule,
  }
});